import React from 'react';
import './style.css';
import TemporaryDrawer from './drawer';
import { Link } from 'react-router-dom';

const primaryLinks = [
    { to: "/overview", label: "Overview" },
    { to: "/dashboard", label: "Market Tracker" },
    { to: "/market-tracker-classic", label: "Markets" },
    { to: "/signal-center", label: "Signal Center" },
    { to: "/token-risk", label: "Token Risk" },
    { to: "/smart-money", label: "Wallets" },
    { to: "/auto-trading", label: "Auto Trading" },
    { to: "/bot-lab", label: "Bot Lab" },
    { to: "/anomaly", label: "Anomalies" },
    { to: "/graph", label: "Graph" },
    { to: "/signals", label: "Discovery" },
];

const secondaryLinks = [
    { to: "/clusters", label: "Clusters" },
    { to: "/behavior-deep", label: "Behavior" },
    { to: "/event-flow", label: "Event Flow" },
    { to: "/raw", label: "Raw" },
    { to: "/feed", label: "Signals" },
];

function Header() {
    return (
        <div className='header'>
            <Link to="/overview" className="brand-link">
                <h1 className='logo'>
                    ChainIntel<span style={{ color: 'var(--primary)' }}>.</span>
                </h1>
            </Link>
            <div className='links'>
                {primaryLinks.map((link) => (
                    <Link to={link.to} key={link.to}>
                        <p className="link">{link.label}</p>
                    </Link>
                ))}

                <div className="header-more">
                    <span className="link">More</span>
                    <div className="header-more-menu">
                        {secondaryLinks.map((link) => (
                            <Link to={link.to} key={link.to}>
                                <p className="link">{link.label}</p>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
            <div className="mobile-drawer">
                <TemporaryDrawer />
            </div>
        </div>
    )
}

export default Header
